import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SearchIcon from '@mui/icons-material/Search';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import reactStringReplace from 'react-string-replace';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type AutoCompleteResultProps = {
  result: string;
  searchQuery: string;
  variant: 'trending' | 'suggestion' | 'recent';
  handleClick: () => void;
};

export const AutoCompleteResult = ({
  result,
  searchQuery,
  variant,
  handleClick,
}: AutoCompleteResultProps) => {
  const theme = useTheme();
  const iconSx = {
    color: theme.palette.text.secondary,
    height: 18,
    width: 18,
    mr: 2,
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        '&:hover': {
          cursor: 'pointer',
          background: theme.palette.background.elevation[23],
          borderRadius: 4,
          // to get around padding
          boxShadow:
            '8px 0px 0 rgb(11 68 112 / 80%), -8px 0px 0 rgb(11 68 112 / 80%)',
        },
      }}
      onClick={handleClick}
    >
      {variant === 'trending' && <TrendingUpIcon sx={iconSx} />}
      {variant === 'suggestion' && <SearchIcon sx={iconSx} />}
      {variant === 'recent' && <QueryBuilderIcon sx={iconSx} />}
      <Typography
        sx={{
          fontWeight: 700,
          color: variant === 'recent' ? '#E8A4F3' : theme.palette.text.primary,
        }}
      >
        {reactStringReplace(result, searchQuery, (match) => (
          <span style={{ fontWeight: 400 }}>{match}</span>
        ))}
      </Typography>
    </Box>
  );
};
